<template>
  <!-- Authors Table Card -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: '0 20px' }"
  >
    <div
      style="
      margin-top: 20px;
        background-color: #edf5ff;
        display: inline-block;
        padding: 5px 10px;
        border-radius: 5px;
      "
    >
      <a-icon style="margin-right: 5px;" type="exclamation-circle" />
      <span
        >邮件格式为个人对账时，需用户重新发送【支付宝-用于材料证明】【微信-用做证件材料】的邮件。</span
      >
    </div>

    <div class="seareh_box">
      <a-form layout="inline" :form="form" @submit="handleSubmit">
        <a-form-item label="姓名">
          <a-input v-model="searchKey" placeholder="请输入用户姓名" />
        </a-form-item>

        <a-form-item label="报告类型">
          <a-select style="width: 120px" v-model="type">
            <a-select-option
              v-for="(item, index) in typeList"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="时间">
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="time" />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="submit"> 查询 </a-button>
        </a-form-item>


        <a-form-item>
          <a-upload
              v-model:file-list="fileList"
              name="file"
              :multiple="false"
              :action="uploadPdfUrl"
              :headers="headers"
              :before-upload="beforeUpload"
              @change="handleChange"
          >
            <a-button style="background: #ff4d4f;color: #ffffff">
              手动上传PDF
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :pagination="pagination"
      :data-source="tableData"
      @change="tableChange"
    >
      <div
        slot="wxBatchNo"
        slot-scope="text, record"
        style="display: flex; align-items: center; justify-content: flex-start"
      >
        <div class="icon_class" v-if="record.wxBatchNo">
          <img
            style="width: 24px; height: 24px"
            src="data:image/png;base64,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"
          />
          <!-- <a-icon type="wechat" style="font-size: 24px; color: #28c445" /> -->
        </div>
        <div class="icon_class" v-if="record.alipayBatchNo">
          <img
            style="width: 24px; height: 24px"
            src="data:image/png;base64,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"
          />
          <!-- <a-icon
            type="alipay-circle"
            style="font-size: 24px; color: #3892f8"
          /> -->
        </div>
      </div>

      <div slot="nameType" slot-scope="text, record">
        <span v-if="record.name != '-'"> 材料证明 </span>
        <span v-else> 个人对账 </span>
      </div>

      <div slot="action" slot-scope="text, record">
        <span @click="toDetail(record)" class="btn_text">查看报告</span>
      </div>
    </a-table>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import { getReportList } from "@/api/user";
import { openLink } from "@/utils/config";
import SettingMer from "@/utils/settingMer";
import store from "@/store";

const table1Columns = [
  {
    title: "ID",
    dataIndex: "id",
    scopedSlots: { customRender: "id" },
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "报告类型",
    dataIndex: "wxBatchNo",
    scopedSlots: { customRender: "wxBatchNo" },
  },
  {
    title: "邮件格式",
    dataIndex: "name",
    scopedSlots: { customRender: "nameType" },
  },

  // {
  //   title: "页数",
  //   dataIndex: "pagesNum",
  // },
  {
    title: "发送时间",
    dataIndex: "createTime",
  },

  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const token = !store.getters.token
    ? localStorage.getItem("token")
    : store.getters.token;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  data() {
    return {
      uploadLoading: false,
      uploadPdfUrl: SettingMer.apiBaseURL+'c/report/uploadPdf',
      fileList:[],
      headers: {
        token: token,
      },
      userInfo: {},
      searchKey: "",
      columns: table1Columns,
      tableData: [],
      stateList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "解析完成",
        },
        {
          value: "2",
          label: "解析中",
        },
        {
          value: "3",
          label: "解析失败",
        },
      ],
      type: "0",
      time: [],
      typeList: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "支付宝",
        },
        {
          value: "2",
          label: "微信",
        },
      ],
      pagination: {
        showQuickJumper: true,
        showSizeChanger: true,
        total: 3,
        pageSize: 10,
        current: 1,
      },
      // Active button for the "Authors" table's card header radio button group.
      hasErrors,
      form: this.$form.createForm(this, { name: "horizontal_login" }),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getReportList();
      // To disabled submit button at the beginning.
      this.form.validateFields();
      let userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
      }
    });
  },
  methods: {
    submit() {
      this.pagination.current = 1;
      this.getReportList();
    },
    handleChange(info) {
      console.log(info.file)
      console.log(info.file.response)

      const  res = info.file.response;

      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false;
        this.fileList = []
        if (res.code===200){
          this.$message.success("上传成功，请在1分钟后点击查询按钮或者刷新页面查看报表");
        }else {
          this.$message.error('请上传正确的账单PDF!');
        }

      }
    },
    beforeUpload(file) {
      console.log(file.type)
      const isJpgOrPng = file.type === 'application/pdf';
      if (!isJpgOrPng) {
        this.$message.error('只能上传PDF文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('文件不能超过10MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    getReportList() {
      getReportList({
        searchKey: this.searchKey,
        type: this.type,
        startCreateTime: this.time[0] || "",
        endCreateTime: this.time[1] || "",
        current: this.pagination.current,
        size: this.pagination.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.pagination.total = res.total;
      });
    },

    filtersData(value, listName) {
      let text = "";
      this[listName].forEach((item) => {
        if (value == item.value) {
          text = item.label;
        }
      });
      return text;
    },
    tableChange(e) {
      this.pagination = e;
      this.getReportList();
    },
    // Only show error after a field is touched.
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("userName") && getFieldError("userName");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
    toDetail(row) {
      window.open(
        openLink + "?id=" + row.id + "&accountId=" + this.userInfo.id
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.seareh_box {
  padding: 20px 10px;
}
.btn_text {
  color: #0078fa;
  cursor: pointer;
}
.icon_class {
  margin-right: 10px;
}
</style>
